import { DeclarationFile } from "../interfaces";

export const allLibs = ["general","lodash","moment","pipes"];

export async function importLib(lib: string): Promise<DeclarationFile[]> {
  switch (lib) {
    case "general":
      return (await import(/* webpackChunkName: "chunks/general" */"./general.json")).default;
    case "lodash":
      return (await import(/* webpackChunkName: "chunks/lodash" */"./lodash.json")).default;
    case "moment":
      return (await import(/* webpackChunkName: "chunks/moment" */"./moment.json")).default;
    case "pipes":
      return (await import(/* webpackChunkName: "chunks/pipes" */"./pipes.json")).default;
    default:
      return [];
  }
}
